import LoaderDots from './loaderDots'
export default LoaderDots
